import React, { FC } from 'react';

import { ITeam } from '../types';

import ImgTeamBorder from '@/shared/pictures/team_border.png';
import ImgTeamPuck from '@/shared/pictures/team_puck.png';

import ImgGoldTeam from '@/shared/pictures/team_gold.png';
import ImgSilrevTeam from '@/shared/pictures/team_silver.png';
import ImgBronzeTeam from '@/shared/pictures/team_bronze.png';
import { Link } from 'react-router';


interface TeamItemProps {
  team:ITeam
}

const getImgPlace = (index:number) => {
  switch(index){
    case 3:
      return <img className='teams-place_img' src={ImgBronzeTeam} alt="team-img" />
    case 2:
      return <img className='teams-place_img' src={ImgSilrevTeam} alt="team-img" />
    case 1:
      return <img className='teams-place_img' src={ImgGoldTeam} alt="team-img" />
    default:
      return null
  }
}

export const TeamItem:FC<TeamItemProps> = ({team}) => {

  return (
    <Link to={'/team?id='+team.id} className='teams-list_item'>
        <div className='teams-list_left'>
          <div className='teams-list_img-block'>
            <img className='teams-list_img' src={team.imageUrl} alt="team-img"/>
            <img className='teams-list_border' src={ImgTeamBorder} alt="team-img"/>
          </div>

          <div className='teams-list_info'>
            <p className='teams-list_name'>{team.name}</p>
            <p className='teams-list_members'>{`Участников: ${team.membersCount}`}</p>
          </div>
        </div>

        <div className='teams-list_score'>
          <img className='teams-list_score-puck' src={ImgTeamPuck} alt="team-puck"/>
          <p className='teams-list_score-text'>{team.totalScore}</p>
        </div>

        {getImgPlace(team.rating)}
    </Link>

  );
};
